import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Button from '~~elements/Button';
import Form from '~~elements/Form';
import { currencyDisplay } from '../service';
import { SectionDiv } from '../styled';
import CTMultilingual from '../Multilingual';
import { useCreateTournamentDispatch, useCreateTournamentState } from '../useCreateTournament';

const Plugins = ({ pluginsPrice, backLink, handleSubmit }) => {
  const { plugins, isFree, creatable, apiLoading } = useCreateTournamentState();
  const dispatch = useCreateTournamentDispatch();

  const getPriceDisplay = (targetPlugin) => {
    if (!pluginsPrice || !pluginsPrice.currency || !pluginsPrice[targetPlugin]) {
      throw new Error();
    }

    if (!currencyDisplay[pluginsPrice.currency]) {
      throw new Error();
    }
    const currency = currencyDisplay[pluginsPrice.currency];

    // 賣價不應該高於原價
    if (pluginsPrice[targetPlugin].list_price < pluginsPrice[targetPlugin].retail_price) {
      throw new Error();
    }

    const listPrice = `${currency.text} ${pluginsPrice[targetPlugin].list_price.toFixed(currency.toFixed)}`;
    const retailPrice = `${currency.text} ${pluginsPrice[targetPlugin].retail_price.toFixed(currency.toFixed)}`;

    if (listPrice === retailPrice) {
      return <i className="info --same-size">{retailPrice}</i>;
    }

    return (
      <i className="info --same-size">
        <span style={{ textDecoration: 'line-through', marginRight: '0.1rem' }}>{listPrice}</span>
        {retailPrice}
      </i>
    );
  };

  const handleCheckboxOnChange = (e) => {
    dispatch({ type: 'UPDATE_PLUGIN', payload: e.target.name });
  };

  return (
    <SectionDiv>
      <Link
        to={(location) => ({
          ...location,
          pathname: backLink,
        })}
      >
        <Button width="unset" color="transparentWithBorder" nowrap>
          {CTMultilingual(`FORM.PRE_STEP`)}
        </Button>
      </Link>
      <Form onSubmit={handleSubmit}>
        <div className="box">
          <div className="input-field" />
          {/* 報名系統 */}
          <label>
            <input
              type="checkbox"
              name="open_registration"
              checked={plugins.open_registration}
              onChange={handleCheckboxOnChange}
              disabled={apiLoading}
            />
            {CTMultilingual('TOURNAMENT.PLUGIN.OPEN_REGISTRATION')}
            {getPriceDisplay('open_registration')}
            <i>{CTMultilingual(`FORM.SUGGEST`)}</i>
          </label>
          <div className="description">{CTMultilingual('TOURNAMENT.PLUGIN.OPEN_REGISTRATION_DESCRIPTION')}</div>
          <div className="input-field" />
          {/* 花絮擴充 */}
          <label>
            <input
              type="checkbox"
              name="expand_media_space"
              checked={plugins.expand_media_space}
              onChange={handleCheckboxOnChange}
              disabled={apiLoading}
            />
            {CTMultilingual('TOURNAMENT.PLUGIN.EXPAND_MEDIA_SPACE')}
            {getPriceDisplay('expand_media_space')}
            <i>{CTMultilingual(`FORM.SUGGEST`)}</i>
          </label>
          <div className="description">{CTMultilingual('TOURNAMENT.PLUGIN.EXPAND_MEDIA_SPACE_DESCRIPTION')}</div>
          <div className="input-field" />
          {/* 紙本紀錄上傳 */}
          <label>
            <input
              type="checkbox"
              name="paper_record_online"
              checked={plugins.paper_record_online}
              onChange={handleCheckboxOnChange}
              disabled={apiLoading}
            />
            {CTMultilingual('TOURNAMENT.PLUGIN.PAPER_RECORD_ONLINE')}
            {getPriceDisplay('paper_record_online')}
          </label>
          <div className="description">{CTMultilingual('TOURNAMENT.PLUGIN.PAPER_RECORD_ONLINE_DESCRIPTION')}</div>
          <div className="input-field" />
          {/* 線下特派員 */}
          <label>
            <input
              type="checkbox"
              name="offline_commissioner"
              checked={plugins.offline_commissioner}
              onChange={handleCheckboxOnChange}
              disabled={apiLoading}
            />
            {CTMultilingual('TOURNAMENT.PLUGIN.OFFLINE_COMMISSIONER')}
            {getPriceDisplay('offline_commissioner')}
          </label>
          <div className="description">{CTMultilingual('TOURNAMENT.PLUGIN.OFFLINE_COMMISSIONER_DESCRIPTION')}</div>
          <div className="input-field" />
          {!isFree ? (
            <Fragment>
              <div className="description">{CTMultilingual(`TOURNAMENT.PLUGIN.SELECT_ANY_TMP_DESCRIPTION`)}</div>
              {!creatable && <i className="error-msg">{CTMultilingual(`BASIC_NOT_COMPLETE`)}</i>}
              <Button width="unset" color="red" nowrap type="submit" disabled={!creatable || apiLoading}>
                {CTMultilingual(`FORM.NEXT_STEP`)}
              </Button>
            </Fragment>
          ) : (
            <Fragment>
              <div className="description">{CTMultilingual(`TOURNAMENT.PLUGIN.SELECT_NOTHING_DESCRIPTION`)}</div>
              {!creatable && <i className="error-msg">{CTMultilingual(`BASIC_NOT_COMPLETE`)}</i>}
              <Button width="unset" color="red" nowrap type="submit" disabled={!creatable || apiLoading}>
                {CTMultilingual(`COMMON.CREATE`)}
              </Button>
            </Fragment>
          )}
        </div>
      </Form>
    </SectionDiv>
  );
};

export default Plugins;
